// export const validateUrlRegex =
//     /^(?:(?:https?|ftp):\/\/)(?:[^@\n]+@)?(?:[^:\/\n]+)(?::\d+)?(?:\/[^?\n]*)?(?:\?[^#\n]*)?(?:#[^\n]*)?$/i;

export const validateUrlRegex =
    /^(?:(?:https?|ftp):\/\/)(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|localhost|(?:(?:\d{1,3}\.){3}\d{1,3}))(?::\d+)?(?:\/\S*)?$/i;

export const validateHexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/i;

export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
